import { render, staticRenderFns } from "./ProductMiniList.vue?vue&type=template&id=c07658e2"
import script from "./ProductMiniList.vue?vue&type=script&lang=js"
export * from "./ProductMiniList.vue?vue&type=script&lang=js"
import style0 from "./ProductMiniList.vue?vue&type=style&index=0&id=c07658e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports